import { $api } from '@service/RequestService';
import { Pagination } from '@utils/models/Pagination';
import { useInfiniteQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export const useLeadGroupTableFilterInfinity = (
  {
    enabled,
    ...props
  }: { size: number; enabled?: boolean; pipeId?: number; pipeStatusIds?: number[]; responsibleById?: number[] } = {
    size: 10
  }
) =>
  useInfiniteQuery<Pagination<crmModels.ILeadGroupTableFilter>>({
    queryKey: [crmConstants.queryKeys.LEAD_GROUP_TABLE_FILTER_INFINITY, props, enabled],
    queryFn: async ({ pageParam = 1 }) => {
      const res = await $api.post('/v1/lead/group/table-filter', { ...props, page: pageParam });

      return {
        ...res?.data?.data,
        params: props
      };
    },
    getNextPageParam: (lastPage, page) => {
      if (page.length < lastPage?.totalElements / props?.size) {
        return page.length + 1;
      }
      return undefined;
    },
    enabled,
    staleTime: Infinity
  });
